/**
 * @deprecated
 * @type {{NONE: string; PIXEL: string; SUBPIXEL: string}}
 */
export const GridFitType = {
    NONE: "none",
    PIXEL: "pixel",
    SUBPIXEL: "subpixel"
};
